var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$store.state.showFramework)?[_c('framework',[_c('Router-view')],1)]:[_c('Router-view')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }